import { ProductCardWrapper, ProductImage, ProductTitle } from "./ProductCard.styled";

const ProductCard = ({product, onClick}) => {
  return (
    <ProductCardWrapper key={product.id} style={{
      // backgroundImage: `url(${product.image})`,
    }}
      onClick={() => onClick()}
    >
      <ProductImage src={product.image} alt={product.name} loading='lazy' />
      <ProductTitle>{product.name}</ProductTitle>
    </ProductCardWrapper>
  )
}

export default ProductCard;